import { render } from "./VueFooter.vue?vue&type=template&id=6292865e&scoped=true"
import script from "./VueFooter.vue?vue&type=script&lang=js"
export * from "./VueFooter.vue?vue&type=script&lang=js"

import "./VueFooter.vue?vue&type=style&index=0&id=6292865e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6292865e"]])

export default __exports__